import React from "react";
import "./compliance.css";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import andres from "../../assets/imgs/compliance_imgs/redesign-compliance/compliance-2.png";
import { FaArrowRight } from "react-icons/fa";

const Commitment = () => {
  const [tCompliance] = useTranslation("compliance");
  const [scrollY, setScrollY] = useState(0);
  const [animation3, setAnimation3] = useState(false);

  const handlescroll = () => {
    setScrollY(window.scrollY || window.pageYOffset);
  };

  useEffect(() => {
    window.addEventListener("scroll", handlescroll);
    return () => window.removeEventListener("scroll", handlescroll);
  }, []);

  useEffect(() => {
    setAnimation3(scrollY >= 400);
  }, [scrollY]);

  const [showMore, setShowMore] = useState(false);
  const toggleShowMore = () => setShowMore(!showMore);

  return (
    <section className="compliance-commitment">
      <div className="compliance-commitment__inner">
        <div className="row align-items-center g-4 g-lg-5">
          <div className="col-12 col-lg-5 text-center text-lg-start">
            <img
              src={andres}
              alt=""
              className="compliance-commitment__photo img-fluid"
            />
          </div>
          <div className="col-12 col-lg-7">
            <p
              className={
                animation3
                  ? "compliance-commitment__name animate__animated animate__fadeInUp"
                  : "compliance-commitment__name"
              }
            >
              {tCompliance("body.andres")}
            </p>
            <h2
              className={
                animation3
                  ? "compliance-commitment__title animate__animated animate__fadeInUp"
                  : "compliance-commitment__title"
              }
            >
              {tCompliance("body.cumplir")}
            </h2>
            <div className="compliance-commitment__body">
              <p>{tCompliance("body.texto1")}</p>
              <p>{tCompliance("body.texto2")}</p>
              {showMore && (
                <>
                  <p>{tCompliance("body.texto3")}</p>
                  <p>{tCompliance("body.texto4")}</p>
                  <p>{tCompliance("body.texto5")}</p>
                  <p>{tCompliance("body.texto6")}</p>
                  <p>{tCompliance("body.texto7")}</p>
                  <p>{tCompliance("body.texto8")}</p>
                  <p className="compliance-commitment__signoff">
                    {tCompliance("body.texto9")}
                    <br />
                    {tCompliance("body.texto10")}
                  </p>
                </>
              )}
            </div>
            <button
              type="button"
              onClick={toggleShowMore}
              className="compliance-commitment__readmore"
              id="leerMasCompromiso"
            >
              {showMore ? tCompliance("body.esconder") : tCompliance("body.leer-mas")}
              <FaArrowRight className="ms-2" aria-hidden />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Commitment;
